import * as React from "react"
import type { SVGProps } from "react"
const SvgDatabase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 21.29q-3.78 0-6.39-1.17Q3 18.96 3 17.3v-10q0-1.65 2.64-2.83Q8.28 3.3 12 3.3c3.72 0 4.6.39 6.36 1.17Q21 5.64 21 7.3v10q0 1.67-2.61 2.83A16 16 0 0 1 12 21.3m0-12q2.23 0 4.47-.64Q18.73 8.02 19 7.3q-.27-.72-2.51-1.37a16 16 0 0 0-8.95-.02Q5.36 6.57 5 7.32q.35.74 2.54 1.37 2.19.62 4.46.62m0 4.97a20 20 0 0 0 3.89-.38 14 14 0 0 0 1.67-.47 10 10 0 0 0 1.44-.62v-3a10 10 0 0 1-1.44.63 14 14 0 0 1-1.67.46q-.9.19-1.87.28a21 21 0 0 1-4.07 0 18 18 0 0 1-1.89-.28 13 13 0 0 1-1.66-.47A9 9 0 0 1 5 9.82v3q.63.35 1.4.63.78.27 1.66.46a18 18 0 0 0 3.94.38m0 5a16 16 0 0 0 4.53-.63q1-.3 1.67-.65.68-.36.8-.74v-2.45a10 10 0 0 1-1.44.63 14 14 0 0 1-1.67.46q-.9.18-1.86.29a21 21 0 0 1-4.08 0 18 18 0 0 1-1.89-.3 13 13 0 0 1-1.66-.45A9 9 0 0 1 5 14.8v2.48q.13.38.79.72.67.35 1.66.64a17 17 0 0 0 4.55.64" />
  </svg>
)
export default SvgDatabase
